import { useFetchTopBannersQuery } from '../actions/fetchTopBanners';
import { useTopBannerUsers } from './useTopBannerUsers';

export const useCurrentTopBanner = () => {
  const { data } = useFetchTopBannersQuery();

  const { loaded, users } = useTopBannerUsers();

  const banners = data?.filter(
    banner => banner.isVisible && users.includes(banner.users),
  );

  const topBanner = banners?.[0];

  return { loaded, topBanner };
};
